"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 11.9",
    width: "34",
    height: "11.9"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M30.5,7.6h-28C2.2,7.6,2,7.4,2,7.1s0.2-0.5,0.5-0.5h28c0.3,0,0.5,0.2,0.5,0.5S30.8,7.6,30.5,7.6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M33.5,7.6h-3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h3c0.3,0,0.5,0.2,0.5,0.5S33.8,7.6,33.5,7.6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M3.5,7.6h-3C0.2,7.6,0,7.4,0,7.1s0.2-0.5,0.5-0.5h3C3.8,6.6,4,6.8,4,7.1S3.8,7.6,3.5,7.6z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "11.4",
    y: "7.3",
    fill: "#EC6833",
    width: "10.7",
    height: "1.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M22.1,9.4H11.4c-0.3,0-0.5-0.2-0.5-0.5V7.3c0-0.3,0.2-0.5,0.5-0.5h10.7c0.3,0,0.5,0.2,0.5,0.5v1.6 C22.6,9.2,22.4,9.4,22.1,9.4z M11.9,8.4h9.7V7.8h-9.7V8.4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M8,11.9c-1.4,0-2.5-1.1-2.5-2.5S6.6,6.9,8,6.9s2.5,1.1,2.5,2.5S9.4,11.9,8,11.9z M8,7.9 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S8.8,7.9,8,7.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M3.6,11.9c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S5,11.9,3.6,11.9z M3.6,7.9 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S4.4,7.9,3.6,7.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M29.8,11.9c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S31.2,11.9,29.8,11.9z M29.8,7.9 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S30.7,7.9,29.8,7.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M25.4,11.9c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S26.8,11.9,25.4,11.9z M25.4,7.9 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S26.2,7.9,25.4,7.9z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#EC6833",
    cx: "16.8",
    cy: "3.1",
    r: "3.1"
  }));
};

exports["default"] = _default;